import { Extension } from '@tiptap/react';
import type { Doc as YDoc } from 'yjs';

import {
  observeDocumentSettings,
  observeNumberingFormats,
  readNumberingFormats,
} from 'containers/Tiptap/components/tiptap-extension/document-settings-yjs';

export interface NumberingFormatsSyncOptions {
  ydoc: YDoc | null;
}

// Registers the ydoc's docx-import numbering-format registry
export const NumberingFormatsSync = Extension.create<NumberingFormatsSyncOptions>({
  name: 'numberingFormatsSync',

  addOptions() {
    return { ydoc: null };
  },

  onCreate() {
    const { ydoc } = this.options;
    if (!ydoc) return;

    const apply = (): void => {
      const formats = readNumberingFormats(ydoc);
      if (formats.length === 0) return;
      if (typeof this.editor.commands.registerNumberingFormats !== 'function') return;
      type ConvertKitFormats = Parameters<typeof this.editor.commands.registerNumberingFormats>[0];
      this.editor.commands.registerNumberingFormats(formats as unknown as ConvertKitFormats);
    };

    apply();
    const unobserveNew = observeNumberingFormats(ydoc, apply);
    const unobserveLegacy = observeDocumentSettings(ydoc, apply);
    this.storage.unobserve = () => {
      unobserveNew();
      unobserveLegacy();
    };
  },

  addStorage() {
    return { unobserve: undefined as (() => void) | undefined };
  },

  onDestroy() {
    this.storage.unobserve?.();
  },
});
